exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select2-search__field {\r\n    display: none;\n}\r\n", ""]);

// exports
